import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';

interface ExternalAccountInfoProps {
    user: UserType;
    accountName: string;
    externalAccount?: UserExternalAccountType;
    setServerError: (e: { message: string }) => void;
    editable: boolean;
}
export function ExternalAccountInfo({
    user,
    accountName,
    externalAccount,
    editable,
    setServerError,
}: ExternalAccountInfoProps) {
    const { removeExternalAccount } = useAdminService();
    const [confirmUnlink, setConfirmUnlink] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    async function unlinkUser() {
        try {
            setLoading(true);
            await removeExternalAccount(user, externalAccount?.id);
            setLoading(false);
            setConfirmUnlink(false);
        } catch (e) {
            setLoading(false);
            setConfirmUnlink(false);
            setServerError(e);
        }
    }

    return (
        <div>
            {accountName}: {externalAccount ? 'Enabled' : 'None'}
            {editable && externalAccount && (
                <>
                    {' '}
                    <i
                        className="fa-solid fa-check-circle text-success me-2"
                        title={`${accountName} account linked successfully`}
                    />
                    (
                    <button
                        className="link-button"
                        type="button"
                        onClick={() => setConfirmUnlink(true)}
                        disabled={loading}
                    >
                        Reset
                    </button>
                    )
                </>
            )}
            {confirmUnlink && (
                <div className="text-center mt-3">
                    <p>Are you sure you want to unlink this user&apos;s {accountName} account?</p>
                    <div>
                        <button
                            className="btn btn-secondary me-3"
                            onClick={() => setConfirmUnlink(false)}
                            type="button"
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-danger"
                            disabled={loading}
                            onClick={unlinkUser}
                            type="button"
                        >
                            {loading && (
                                <Spinner
                                    animation="border"
                                    variant="light"
                                    size="sm"
                                    role="status"
                                    className="me-1"
                                />
                            )}
                            Yes
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
